import {
  isTypeContentPageAlternative,
  TypeContentPageAlternativeSkeleton,
} from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulContentPageAlternative = ({
  entry,
}: {
  entry:
    | Entry<TypeContentPageAlternativeSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'>
    | undefined;
}) => {
  if (!entry || !isTypeContentPageAlternative(entry)) {
    return null;
  }

  return (
    <div className='relative'>
      <div
        className='-mx-2 sm:-mx-5 h-[40vh] sm:h-[65vh] min-h-[15rem]'
        style={{
          backgroundImage: `url("${entry.fields.image?.fields.file?.url}?fit=fill&w=1920&h=1280")`,
          backgroundColor: '#f5faff',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter:
            'grayscale(100%) brightness(63%) sepia(100%) hue-rotate(150deg) saturate(350%) contrast(90%)',
        }}
      />
      <div className='absolute w-full top-0 h-full flex items-center justify-center'>
        <h1
          className='max-w-3xl text-white font-header text-2xl sm:text-5xl leading-7 sm:leading-14 font-bold text-center'
          style={{ textShadow: '0 2px 4px #0e14a3' }}
        >
          {entry.fields.header}
        </h1>
      </div>
    </div>
  );
};

export default ContentfulContentPageAlternative;
